import { HttpModelConverter } from '../../../../../../core/converter/httpModel.converter';
import { AgendaEventModel } from '../agendaEvent.model';
import { AgendaEventSummaryConverter } from './agendaEventSummaryConverter';
import { Injectable } from '@angular/core';
import {
    WorkflowTaskSummaryConverter
} from '../../../../../../workflow/task/api/model/common/converter/workflowTaskSummary.converter';
import {
    OnlineFormSummaryConverter
} from "../../../../../../online-form/form/api/entity/converter/onlineFormSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class AgendaEventConverter extends HttpModelConverter<AgendaEventModel>{

    constructor(private workflowTaskSummaryConverter: WorkflowTaskSummaryConverter,
                private summaryConverter: AgendaEventSummaryConverter,
                private onlineFormSummaryConverter: OnlineFormSummaryConverter) {
        super();
    }

    protected createInstance(): AgendaEventModel {
        return new AgendaEventModel();
    }

    protected enrichObject(result: AgendaEventModel, src: AgendaEventModel) {
        result.summary = this.summaryConverter.convert(src.summary);
        result.reminders = this.workflowTaskSummaryConverter.convertFromArray(src.reminders);
        result.onlineForms = this.onlineFormSummaryConverter.convertFromArray(src.onlineForms);
        return result;
    }



}
